import { useAtom } from 'jotai';
import { useEffect } from 'react';

import DatePickerMode from '../../../../../types/DatePickerMode';
import datePickerModeAtLoadAtom from '../../../../atoms/datePickerModeAtLoadAtom';

const useDatePickerModeAtLoad = (datePickerMode: DatePickerMode): void => {
    const [, set] = useAtom(datePickerModeAtLoadAtom);

    useEffect(() => set(datePickerMode), []);
};

export default useDatePickerModeAtLoad;
